import React from 'react'
import styled from 'styled-components'
import { StyledLabel } from '../typography/styles'

interface MenuSectionProps {
  title?: string;
  children?: React.ReactNode;
}

export const SectionLabel = styled(StyledLabel)`
  margin: 0 ${({ theme }) => theme.space.s8};
  padding-bottom: ${({ theme }) => theme.space.s12};
  color: ${({ theme }) => theme.color.grey90};
`

const SectionList = styled.ul`
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  margin: 0;
  padding: 0;

  &:not(:last-child):after {
    content: '';
    margin: ${({ theme }) => theme.space.s8};
    margin-bottom: ${({ theme }) => theme.space.s12};
    border-top: 1px solid ${({ theme }) => theme.color.grey20};
  }
`

export const MenuSection: React.FC<MenuSectionProps> = ({ title, children }) => (
  <>
    {title && <SectionLabel>{title}</SectionLabel>}
    <SectionList>
      {children}
    </SectionList>
  </>
)
